<template>
  <div :style="styleProps" class="modal-wrapper">
    <div class="modal-wrapper__header">
      <h2 :class="lineHeader ? 'modal-wrapper__title-line' : 'modal-wrapper__title'">{{title}}</h2>
      <div class="modal-wrapper__close" @click.prevent="$emit('close')">
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M15 5L5 15"
              stroke="#566A83"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
          <path
              d="M5 5L15 15"
              stroke="#566A83"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div class="modal-wrapper__body">
      <div class="modal-wrapper__form-field">
        <slot />
      </div>
    </div>
    <div v-if="!hiddenBtn" style="gap: 12px; padding: 0 24px 24px 24px; " :style="flexRow ? '' : 'flex-direction: column;' " class="flex    ">
      <VButtonNew
          :label="okBtnTitle"
          class="w-full"
          @click="$emit('apply')"
      />

      <VButtonNew
          label="Отменить"
          style-type="grey"
          class="w-full"
          @click="$emit('close')"
      />
    </div>
  </div>
</template>
<script setup>
import {computed} from "vue";

const props = defineProps({
  width: {
    type: String,
    default: "352px"
  },
  height: {
    type: String,
    default: "auto"
  },
  title: String,
  flexRow: {
    type: Boolean,
  },
  lineHeader: {
    type: Boolean,
  },
  hiddenBtn: {
    type: Boolean,
  },
  okBtnTitle: {
    type: String,
    default: "Добавить"
  }
})
const styleProps = computed(() => {
  return `width: ${props.width}; height: ${props.height};`
})

</script>
<style lang="scss" scoped>

.modal-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 284px;

  &__body {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  &__form-field-error {
    margin-top: 4px;
    font-size: 14px;
    color: $red;
  }

  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }

  &__title {
    margin-bottom: 16px;
    padding-top: 40px;
    font-size: 20px;
    font-weight: 600;
    line-height: 24.2px;
    text-align: center;
  }

  &__title-line {
    padding-bottom: 12px;
    padding-top: 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24.2px;
    text-align: center;
    border-bottom: 1px solid $light-gray-1;
  }

  &__form-field {
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
  }
}
</style>